<template>
	<div>
		<div id="dropin-container"></div>
		<v-btn class="primary large" type="submit" id="submitTransaction" @click="dropinRequestPaymentMethod">Submit</v-btn>
		<v-btn class="secondary large" @click="dialog = false">Cancel</v-btn>
	</div>
</template>

<script>
import axios from 'axios'
import btDropin from 'braintree-web-drop-in'
// const btDropin = require('braintree-web-drop-in')
export default {
	name: 'payment-form',
	props: {
		authToken: {
			value: String
		},
		wrapperClass: {
			value: String
		},
		loaderClass: {
			value: String
		},
		inputClass: {
			value: String
		},
		collectCardHolderName: {
			value: Boolean
		},
		collectPostalCode: {
			value: Boolean
		},
		enableDataCollector: {
			value: Boolean
		},
		enablePayPal: {
			value: Boolean
		}
	},
	data() {
		return {
			dialog: false,
			paymentToken: null,
			dropinOptions: {
				authorization: null,
				selector: '#dropin-container',
				card: {
					cardholderName: { required: true }
				},
				paypal: {
					flow: 'vault'
				}
			},
			errorMessage: '',
			dropinInstance: '',
			paymentPayload: '',
			dataCollectorPayload: ''
		}
	},
	created() {
		if (this.enablePayPal) {
			this.dropinOptions.paypal = {
				flow: 'vault'
			}
		}
		axios
			.get('/api/v1/payment-token/')
			.then(response => {
				this.paymentToken = response.data
			})
			.catch(error => {
				console.error('Error receiving payment token')
				console.error(error)
			})
	},
	watch: {
		paymentToken(newValue, oldValue) {
			if (newValue) {
				this.dropinOptions.authorization = newValue
				this.createDropin()
			}
		}
	},
	methods: {
		createDropin() {
			btDropin.create(this.dropinOptions, (dropinError, dropinInstance) => {
				if (dropinError) {
					this.errorMessage =
						'There was an error setting up the client instance. Message: ' +
						dropinError.message
					this.$emit('bt.error', this.errorMessage)
					return
				}
				this.dropinInstance = dropinInstance
			})
		},
		dropinRequestPaymentMethod() {
			this.dropinInstance.requestPaymentMethod((requestErr, payload) => {
				if (requestErr) {
					this.errorMessage =
						'There was an error setting up the client instance. Message: ' +
						requestErr.message
					this.$emit('bt.error', this.errorMessage)
					return
				}
				this.paymentPayload = payload
				console.log(payload)
				// do something with the payload/nonce
			})
		}
	}
}
</script>

<style lang="scss">
</style>
